<template>
  <section>
    <div class="d-flex justify-content-between align-items-center">
      <h4>{{ $t('EnduserChat.tab_talks') }} - 詳細</h4>
      <button class="btn btn-outline-secondary btn-sm" @click="$router.push({name:'EnduserChatTalks', query: $route.query})">‹ 一覧へ</button>
    </div>
    <hr>

    <div v-if="loading" class="text-muted">{{ $t('EnduserChat.loading') }}</div>
    <div v-else-if="!detail" class="text-muted">{{ $t('EnduserChat.no_data') }}</div>
    <div v-else>
      <!-- メタ情報 -->
      <table class="table table-sm small">
        <tbody>
          <tr>
            <th style="width:120px">{{ $t('EnduserChat.col_talk_id') }}</th>
            <td><code class="fw-bold">{{ detail.display_code || '-' }}</code></td>
            <th style="width:90px">{{ $t('EnduserChat.col_status') }}</th>
            <td>
              <span :class="statusBadgeClass(detail.resolution)">{{ statusLabel(detail.resolution) }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t('EnduserChat.detail_internal_id') }}</th>
            <td colspan="3"><code class="text-muted small">{{ detail.id }}</code></td>
          </tr>
          <tr>
            <th>{{ $t('EnduserChat.col_menu') }}</th><td><span class="badge bg-info-subtle text-dark">{{ menuLabel(detail.menu_kind) }}</span></td>
            <th>開始</th><td>{{ fmtDate(detail.started_at) }}</td>
          </tr>
          <tr>
            <th>{{ $t('EnduserChat.col_user') }}</th><td>{{ detail.user_display_name }}</td>
            <th>Origin</th><td class="text-truncate" style="max-width:200px">{{ detail.origin || '-' }}</td>
          </tr>
        </tbody>
      </table>

      <!-- タイムライン -->
      <div class="mt-3">
        <div v-for="m in detail.messages" :key="m.id" class="d-flex mb-3"
             :class="m.role === 'user' ? 'flex-row-reverse' : ''">
          <div class="avatar" :class="m.role">
            {{ m.role === 'user' ? '👤' : (m.role === 'system' ? '⚙' : '🤖') }}
          </div>
          <div class="mx-2" style="max-width:70%">
            <div class="bubble" :class="m.role">{{ m.message_text }}</div>
            <div class="small text-muted mt-1">
              {{ fmtDateTime(m.sent_at) }} · {{ m.role }}
              <span v-if="m.point_consumed"> · {{ m.point_consumed }}pt</span>
              <span v-if="m.is_unresolved_snapshot" class="text-danger"> · 未解決</span>
              <span v-if="m.rag_chunk_refs && m.rag_chunk_refs.length"> · 参照{{ m.rag_chunk_refs.length }}件</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { enduserChatApi } from "@/api";

export default defineComponent({
  name: "EnduserChatTalkDetailView",
  data() {
    return { loading: true, detail: null, menus: [] };
  },
  methods: {
    // 一覧（EnduserChatTalksView）と同じく、メニューキーを表示名に変換する
    menuLabel(key) {
      const m = this.menus.find(x => x.key === key);
      return m ? m.label : (key || "-");
    },
    async loadMenus() {
      try {
        const cfg = await enduserChatApi.getConfig();
        this.menus = cfg.menu_definitions || [];
      } catch (e) {
        console.error("failed to load menus", e);
      }
    },
    // 解決状態（3値）のラベル・バッジ色。null=空欄（未回答）
    statusLabel(resolution) {
      if (resolution === "resolved") return this.$t("EnduserChat.resolved");
      if (resolution === "unresolved") return this.$t("EnduserChat.unresolved");
      return this.$t("EnduserChat.status_none");
    },
    statusBadgeClass(resolution) {
      if (resolution === "resolved") return "badge bg-success";
      if (resolution === "unresolved") return "badge bg-danger";
      return "badge bg-secondary";
    },
    fmtDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      const p = n => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${p(d.getMonth()+1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    fmtDateTime(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      const p = n => String(n).padStart(2, "0");
      return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
    async load() {
      this.loading = true;
      try {
        this.detail = await enduserChatApi.getTalkDetail(this.$route.params.talk_id);
      } catch (e) {
        console.error("failed to load talk detail", e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadMenus();
    this.load();
  },
});
</script>

<style scoped>
.avatar {
  width: 34px; height: 34px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; background: #e8f3fb;
}
.avatar.user { background: #e0f0d7; }
.bubble {
  padding: 8px 12px; border-radius: 10px; font-size: 13px;
  line-height: 1.5; white-space: pre-wrap; word-break: break-word;
  background: #f3f5f7;
}
.bubble.user { background: #e8f3fb; }
.bubble.system { background: #fff8e1; }
</style>
